import React from 'react';
import checkIcon from '../../assets/accept-icon.svg';
import Link from 'components/acommon/Link';
import {AcceptIconImg, CheckedRoundCheckbox, Box, CheckboxWrapper, Label} from './styled';

export type CheckboxProps = {
  onChange?: (name?: string) => void;
  label?: string | React.ReactNode | JSX.Element;
  disabled?: boolean;
  checked?: boolean;
  round?: boolean;
  className?: string;
  name?: string;
  linkLabel?: string;
  linkHref?: string;
};

const defaultProps: CheckboxProps = {
  onChange: () => {},
  label: '',
  disabled: false,
  checked: false,
  round: false,
  className: undefined,
  name: '',
};

function Checkbox({
  onChange,
  label,
  disabled,
  checked,
  className,
  name,
  round,
  linkLabel,
  linkHref,
}: CheckboxProps) {
  const onClickHandler = disabled ? undefined : onChange;

  const handleCheckboxClick = (event: React.MouseEvent<HTMLDivElement>) => {
    // event.preventDefault();
    // event.stopPropagation();
    if (onClickHandler) {
      onClickHandler(name);
    }
  };

  return (
    <CheckboxWrapper
      onClick={handleCheckboxClick}
      disabled={disabled}
      className={className}
      role="checkbox"
      aria-label={name}
    >
      {round ? (
        <Box checked={checked} round={round}>
          {checked && (
            <CheckedRoundCheckbox
              // src={checkIcon}
              // alt="Check mark"
              data-testid={`${name}-checkmark`}
            />
          )}
        </Box>
      ) : (
        <Box checked={checked}>
          {checked && (
            <AcceptIconImg
              src={checkIcon}
              alt="Check mark"
              data-testid={`${name}-checkmark`}
            />
          )}
        </Box>
      )}
      {label && (
        <>
          <Label>{label}</Label>
          {linkLabel && (
            <Link target="_blank" rel="noreferrer" href={linkHref} action>
              {label}
            </Link>
          )}
        </>
      )}
    </CheckboxWrapper>
  );
}

Checkbox.defaultProps = defaultProps;
export {Checkbox};
